angular.module('tgaApp').controller('RegisterController', [
  '$scope',
  '$rootScope',
  'userService',
  'badWordsFilterService',
  'URLParamsService',
  'analyticsService',
  'scormService',
  'gameConfig',
  'soundService',
  '$translate',
  '$filter',
  '$timeout',
  function (
    $scope,
    $rootScope,
    userService,
    badWordsFilterService,
    URLParamsService,
    analyticsService,
    scormService,
    gameConfig,
    soundService,
    $translate,
    $filter,
    $timeout,
  ) {
    $scope.registrationFields = {};
    $scope.userURLParams = URLParamsService.getUserParams();
    $scope.viewmodel = {
      custom_fields: {},
    };

    $scope.initialize = function () {
      $scope.registrationFieldCount = $scope.countRegistrationFields();
      $scope.canSubmit = false;
      $scope.game.registration.fields.forEach((i) => {
        $scope.registrationFields[i.key] = {
          label: i.condition === 'optional' ? `${i.label} (Optional) ` : i.label,
          condition: i.condition,
          options: i.options,
          value: $scope.userURLParams[i.key] || null,
        };
        // pull in URL params to autofill form
        $scope.viewmodel[i.key] = $scope.userURLParams[i.key] || null;
      });
      $timeout(() => {
        this.formChange();
      });
    };
    $scope.toggleConsent = () => {
      if ($scope.game.privacy_policy_required) {
        $scope.viewmodel.consent = !$scope.viewmodel.consent;
        $timeout(() => $scope.formChange());
      }
    };
    $scope.formChange = () => {
      const formErrors = !Object.keys($scope.registrationForm.$error).length;
      const consent = $scope.game.privacy_policy_required ? $scope.viewmodel.consent : true;
      $scope.canSubmit = formErrors && consent;
    };
    $scope.countRegistrationFields = function () {
      let counter = 0;
      // counts registration fields
      for (let i = 0; i < $scope.game.registration.fields.length; i++) {
        if ($scope.game.registration.fields[i].condition !== null) {
          counter++;
        }
      }
      // counts custom fields that will be shown
      for (let j = 0; j < $scope.game.registration.custom_fields.length; j++) {
        if ($scope.game.registration.custom_fields[j].condition !== null) {
          counter++;
        }
      }
      return counter;
    };

    $scope.actions = {
      submit() {
        if (!gameConfig.sfx_muted) {
          soundService.play('click');
        }

        $scope.submitted = true;

        if ($scope.registrationForm.initials) {
          if (badWordsFilterService.checkWord($scope.viewmodel.initials)) {
            $scope.registrationForm.initials.$setValidity('valid', false);
            $scope.canSubmit = false;
            return;
          }
          $scope.registrationForm.initials.$setValidity('valid', true);
        }

        if ($scope.registrationForm.first_name) {
          if (badWordsFilterService.checkWord($scope.viewmodel.first_name)) {
            $scope.registrationForm.first_name.$setValidity('valid', false);
            $scope.canSubmit = false;
            return;
          }
          $scope.registrationForm.first_name.$setValidity('valid', true);
        }

        if ($scope.registrationForm.$invalid) {
          return;
        }

        if ($scope.viewmodel.segment) {
          URLParamsService.userParams.segment = $scope.viewmodel.segment;
        }

        if ($scope.game.authorization_type === 1) {
          const email = $scope.viewmodel.email || $scope.userURLParams.email;
          // eslint-disable-next-line max-len
          const username = $scope.userURLParams.username || $scope.viewmodel.employee_id || $scope.userURLParams.employee_id;

          userService.checkAuthorizedUser({
            slug: $scope.game.slug,
            email,
            username,
            user_list_id: $scope.game.user_list_id,
          })
            .then((authorized) => {
              if (authorized) {
                $scope.processing = true;
                $scope.viewmodel.username = email || username;
                $scope.viewmodel.display_name = $scope.viewmodel.first_name || $scope.viewmodel.initials;

                userService.register($scope.viewmodel).then(() => {
                // all done move on to tutorial
                  $scope.setState('game');
                });
              } else {
                $scope.setState('unauthorized');
              }
            });
        } else {
          $scope.processing = true;
          // eslint-disable-next-line max-len
          $scope.viewmodel.username = $scope.userURLParams.username || $scope.viewmodel.email || $scope.viewmodel.employee_id;
          $scope.viewmodel.display_name = $scope.viewmodel.first_name || $scope.viewmodel.initials;
          userService.register($scope.viewmodel).then(() => {
            // all done move on to tutorial
            $rootScope.display_name = $scope.viewmodel.display_name;
            $scope.setState('game');
          });
        }
      },
    };

    $scope.generatePrivacyPolicy = () => {
      const tgaPrivacy = 'https://www.elblearning.com/legal/privacy-policy/';
      const legal = 'https://www.elblearning.com/legal/subscription-and-license-agreement/';

      const companyPrivacy = $scope.game.privacy_policy_url;
      const companyName = $scope.game.privacy_policy_name;
      let message = $translate.instant(
        `scenarios.registration.${$scope.game.privacy_policy_required ? 'pp_checkbox_message' : 'pp_message'}`,
      ).toString();
      const privacyTranslation = $translate.instant('scenarios.pause.privacy').toString();
      const legaTranslation = $translate.instant('scenarios.pause.legal').toString();

      message = message.replace('{',
        `<a href="${tgaPrivacy}" target="_blank" ng-click="$event.stopPropagation()">`);
      message = message.replace('Privacy Policy', privacyTranslation);
      message = message.replace('}', '</a>');
      message = message.replace('{',
        `<a href="${legal}" target="_blank" ng-click="$event.stopPropagation()">`);
      message = message.replace('Legal', legaTranslation);
      message = message.replace('}', '</a>');
      message = message.replace('[', '<span style="white-space:nowrap;">');
      message = message.replace(']', '</span>');

      if (companyPrivacy && companyName) {
        let companyMessage = $translate.instant('scenarios.registration.pp_company_message').toString();
        companyMessage = companyMessage.replace('{',
          `<a href="${companyPrivacy}" target="_blank" ng-click="$event.stopPropagation()">`);
        companyMessage = companyMessage.replace('}', '</a>');
        companyMessage = companyMessage.replace('Privacy Policy', privacyTranslation);
        companyMessage = companyMessage.replace('<COMPANY_NAME>', companyName);
        companyMessage = companyMessage.replace('[', '<span style="white-space:nowrap;">');
        companyMessage = companyMessage.replace(']', '</span>');
        message = `${message} ${companyMessage}`;
      }

      message = $filter('noWrapReplaceAll')(message, [
        'The Training Arcade®',
        'ELB Learning',
      ]);

      return $filter('unsafe')(message);
    };
    $scope.initialize();
  },
]);
